import React, {PropsWithChildren} from 'react';
import ShowHideButton from 'shared/components/show-hide-button';
import Icon from 'shared/components/icon';
import ActionMenu from './action-menu';
import styles from './action-menu.module.scss';

const MenuButton = ShowHideButton('MenuButton', Icon, ActionMenu);

interface Props {
  className?: string;
  iconType?: string;
}

const ActionMenuButton = ({
  className = styles.menuButtonIcon,
  children,
  iconType = 'ellipsis-v',
}: Props & PropsWithChildren) => (
  <MenuButton
    className={styles.menuButton}
    parentProps={{className, iconType}}
    childProps={{children}}
  />
);

export default ActionMenuButton;
